import Model, { attr, hasMany } from "@ember-data/model";
import type HealthCentre from "parog-web/models/health-centre";
import type CompoundQuestion from "./compound-question";

interface Question {
  id: string;
  label: string;
  answers: string[];
}

export type SerializedSurvey = Question[];

export default class CompoundSurvey extends Model {
  @attr("string") declare title: string;

  @hasMany("compound-question", {
    async: false,
    inverse: "surveys"
  })
  declare questions: CompoundQuestion[];

  @hasMany("health-centre", {
    async: false,
    inverse: "surveys"
  })
  declare healthCentres: HealthCentre[];

  serialize(): SerializedSurvey {
    return this.questions.map(q => {
      return {
        id: q.id,
        label: q.label,
        answers: [...q.answers]
      };
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "compound-survey": CompoundSurvey;
  }
}
